export const REQUEST_PAGE = "requestPage";
export const REQUEST_PRODUCTS = "requestProducts";
export const REQUEST_ORDER = "requestOrder";
export const GET_INVOICE = "getCheckoutResult";
